"use client"
import { Box, Button, Stack, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { Icon } from "@iconify/react";
import { initiativePatchApi } from './initiative.service';
import { resultMessage } from '../../../../service/apiResult';

const dialogStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '92%', sm: 440 },
    bgcolor: '#FFFFFF',
    border: 'none',
    boxShadow: '0px 24px 48px rgba(28, 27, 31, 0.18)',
    borderRadius: '28px',
    p: 3,
};

export default function InitiativeStatusModal(props) {

    const { onClose, getInitiativeData, selectedId, selectedStatus, setResponseMsg, setAlert, setOpenAlert, setLoading, ALERT_DURATION, alertClose } = props;

    const isDeactivating = selectedStatus === 'ACTIVE' || selectedStatus === 'Active';
    const statusUpdate = isDeactivating ? 'INACTIVE' : 'ACTIVE';

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        const res = await initiativePatchApi(selectedId, statusUpdate);
        if (res.success) {
            setResponseMsg(resultMessage(res, 'Initiative status updated'));
            setLoading(false)
            setAlert('true');
            setOpenAlert(true);
            setTimeout(() => {
                alertClose();
                getInitiativeData();
                onClose();
            }, ALERT_DURATION);
        } else {
            // Show what the server actually said, not a guess: these refusals name the
            // obstacle, and that is the whole value of them.
            setResponseMsg(resultMessage(res));
            setAlert('false');
            setOpenAlert(true);
            setLoading(false);
            // Close so the message behind the modal is readable. Nothing changed, so
            // there is nothing to refresh.
            onClose();
        }
    };

    return (
        <Box sx={dialogStyle}>
            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 1 }}>
                <Button
                    onClick={onClose}
                    sx={{
                        minWidth: 'auto',
                        p: 0.5,
                        color: '#6B7280',
                        borderRadius: '999px',
                    }}
                >
                    <CloseIcon />
                </Button>
            </Stack>

            <form onSubmit={onSubmit}>
                <Stack spacing={2} alignItems="center" textAlign="center">
                    <Box
                        sx={{
                            width: 72,
                            height: 72,
                            borderRadius: '50%',
                            bgcolor: '#FDE1DC',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Icon icon="material-symbols:warning-rounded" width="36" height="36" color="#DA342E" />
                    </Box>

                    <Typography
                        className="app-page-title"
                        sx={{
                            fontSize: 24,
                            lineHeight: '32px',
                            letterSpacing: 0,
                            fontWeight: 700,
                            color: '#1C1B1F',
                        }}
                    >
                        {isDeactivating ? 'Deactivate Initiative?' : 'Activate Initiative?'}
                    </Typography>

                    <Typography
                        sx={{
                            maxWidth: 340,
                            fontSize: 16,
                            lineHeight: '24px',
                            letterSpacing: '0.15px',
                            color: '#49454F',
                        }}
                    >
                        {isDeactivating
                            ? 'This will mark the initiative as inactive. You can enable it again later.'
                            : 'This will make the initiative active and available again.'}
                    </Typography>

                    <Stack direction="row" spacing={1.5} justifyContent="center" sx={{ pt: 1 }}>
                        <Button
                            onClick={onClose}
                            sx={{
                                minWidth: 96,
                                height: 40,
                                px: 2,
                                borderRadius: '999px',
                                textTransform: 'none',
                                color: '#DA342E',
                                fontSize: 14,
                                lineHeight: '20px',
                                letterSpacing: '0.1px',
                                fontWeight: 500,
                            }}
                        >
                            No
                        </Button>
                        <Button
                            variant="contained"
                            type="submit"
                            sx={{
                                minWidth: 96,
                                height: 40,
                                px: 3,
                                borderRadius: '999px',
                                textTransform: 'none',
                                bgcolor: '#4F8506',
                                color: '#FFFFFF',
                                fontSize: 14,
                                lineHeight: '20px',
                                letterSpacing: '0.1px',
                                fontWeight: 500,
                                boxShadow: 'none',
                                '&:hover': {
                                    bgcolor: '#4F8506',
                                    boxShadow: 'none',
                                },
                            }}
                        >
                            Yes
                        </Button>
                    </Stack>
                </Stack>
            </form>
        </Box>
    )
}
